<template>
  <a-modal width="60%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>选择支行</b>
    </a-divider>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('联行号')" prop="code">
                <a-input v-model="queryParam.code" :maxLength="32" :placeholder="$t('请输入')+$t('联行号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行全名')" prop="name">
                <a-input v-model="queryParam.name" :maxLength="32" :placeholder="$t('请输入')+$t('银行全名')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行简称')" prop="bankAlias">
                <a-input v-model="queryParam.bankAlias" :maxLength="32" :placeholder="$t('请输入')+$t('银行简称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行名称')" prop="bankName">
                <a-input v-model="queryParam.bankName" :maxLength="32" :placeholder="$t('请输入')+$t('银行名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行编码')" prop="bankCode">
                <a-input v-model="queryParam.bankCode" :disabled="getBankCodeDisable()" :maxLength="32" :placeholder="$t('请输入')+$t('银行编码')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('城市名称')" prop="cityName">
                <a-input v-model="queryParam.cityName" :maxLength="32" :placeholder="$t('请输入')+$t('城市名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('省份名称')" prop="provinceName">
                <a-select :placeholder="$t('请选择')+$t('省份名称')" style="width: 100%" v-model="queryParam.provinceCode" allowClear>
                  <a-select-option v-for="(item, index) in this.cityList" :value="item.areaId+''" :key="index">
                    {{ item.areaName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6 || 24" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        :loading="loading"
        rowKey="code"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'radio', onChange: onSelectChange}"
        :pagination="false"
        :customRow="loadCustomRow"
        :bordered="false">
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {pageBranch} from "@/api/shop/branch";
import {cityListTree} from "@/api/logistics";

export default {
  name: 'RadioBranchSelectForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      list: [],
      cityList: [],
      bankCode: undefined,
      selectedRowKeys: [],
      selectedRows: [],
      open: false,
      loading: false,
      total: 0,
      queryParam: {
        code: undefined,
        name: undefined,
        bankAlias: undefined,
        bankName: undefined,
        bankCode: undefined,
        cityCode: undefined,
        cityName: undefined,
        orderByCode: undefined,
        haveClearingCode: true,
        provinceCode: undefined,
        provinceName: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('联行号'), dataIndex: 'code', align: 'center' },
        { title: this.$t('银行全名'), dataIndex: 'name', align: 'center' },
        { title: this.$t('银行简称'), dataIndex: 'bankAlias', align: 'center' },
        { title: this.$t('银行名称'), dataIndex: 'bankName', align: 'center' },
        { title: this.$t('银行编码'), dataIndex: 'bankCode', align: 'center' },
        { title: this.$t('城市名称'), dataIndex: 'cityName', align: 'center' },
        { title: this.$t('省份名称'), dataIndex: 'provinceName', align: 'center' },
      ]
    };
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  created() {
    this.getCityTree();
    this.getList();
  },
  methods: {
    onClose() {
      this.open = false
      this.resetQuery()
    },
    openBranch(bankCode, records, areaId) {
      if (bankCode) {
        this.bankCode = bankCode;
        this.queryParam.bankCode = bankCode
      }
      if (areaId) {
        this.queryParam.cityCode = areaId;
      }
      if (records) {
        this.queryParam.orderByCode = records;
      }
      this.getList()
      if (records) {
        this.selectedRowKeys = [records];
      }
      this.open = true;
    },
    openClearBranch(code) {
      this.bankCode = code
      this.getList()
      this.open = true;
    },
    onOk() {
      this.open = false
      this.$emit('branchSelect', this.selectedRows[0])
      this.resetQuery()
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    getBankCodeDisable() {
      if (this.bankCode === null || this.bankCode === undefined || this.bankCode === '') {
        return false
      } else {
        return true
      }
    },
    getCityTree() {
      cityListTree().then(response => {
        this.cityList = response.data
      })
    },
    getList() {
      this.loading = true
      this.queryParam.orderByCode = this.bankCode;
      pageBranch(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      });
    },
    resetQuery() {
      let haveClearingCode = this.queryParam.haveClearingCode
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.queryParam = {
        code: undefined,
        name: undefined,
        bankAlias: undefined,
        bankName: undefined,
        cityCode: undefined,
        cityName: undefined,
        haveClearingCode: haveClearingCode,
        provinceCode: undefined,
        provinceName: undefined,
        pageNum: 1,
        pageSize: 10
      };
      if (this.bankCode) {
        this.queryParam.orderByCode = this.bankCode;
      }
      this.handleQuery();
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    loadCustomRow(record, index) {
      return {
        on: {
          click: () => {
            if (this.selectedRowKeys.find(e => e.id === record.id)) {
              return;
            }
            let selectedRowKeys = [record.code]
            let selectedRows = [record]
            this.onSelectChange(selectedRowKeys, selectedRows)
          }
        }
      }
    },
  }
}
</script>
